import { stateShowSidebarMobile } from '@infinitro/global';
import { writable } from 'svelte/store';
export { jackpotAmounts, jackpotMEGA, startMegajackpotPolling } from './jackpot-mega.svelte';
export const menuAutoCollapse = writable(false);
export const menuAutoCollapsed = writable(false);
export const languageIsExpanded = writable(false);
export const menuMobileOpen = writable(false);
// Sincronizar el estado de menuMobileOpen con stateShowSidebarMobile
stateShowSidebarMobile.subscribe((value) => {
    menuMobileOpen.set(value);
});
